<template lang="pug">
  #contract-neo-confirm
    .d-flex
      b-card.mt-1.flex-grow-1(header-tag="header")
        b-form-text.mx-2.my-2.align-left.text-left.error-message-color(v-for="(error_msg, key) of error_msg_list", :key="key") {{error_msg}}
        b-form(@submit.prevent="send()")
          contract-neo-confirm-data(:regist_data="regist_data", :error_msg_list="error_msg_list", :contract_type="value.contract_type").mx-auto
          contract-conditions.mx-3.mb-4(
            :show-neo="true",
            :show-clouza="value.clouza_check === true",
            :show-arena="value.web_arena === true",
            :show-cyber="value.cyber === true",
            :show-mailgates="value.mailgates === true")
          b-button.float-left.ml-5.my-3(pill, variant="outline-secondary", size="lg", :to="{name: 'ContractNeoOrder'}")
            .float-right.search_message.ml-1.font-weight-bold 戻る
            b-icon.float-left.next-icon(icon="arrow-left-circle")
          b-button.order-confirm-button.float-right.mr-5.my-3(pill, type="submit", variant="outline-success", size="lg", :disabled="isLoading")
            span.search_message.mr-1.font-weight-bold 申し込みを確定する
            b-icon.next-icon(icon="arrow-right-circle")
      price-board(v-model="value")
</template>

<script>
import ContractNeoConfirmData from "@/components/contractOrder/ContractNeoConfirmData";
import ContractConditions from "@/components/ContractConditions";
import PriceBoard from "@/components/PriceBoard";
import Api from '@/repositories/api'
const S203NeoContractOrder = Api.get('s203NeoContractOrder');

export default {
  name: "ContractNeoConfirm",
  props: {
    value: { type: Object, required: true},
  },
  components: {
    PriceBoard,
    ContractConditions,
    ContractNeoConfirmData,
  },
  data() {
    return {
      error_msg_list: [],  // エラーメッセージ
      regist_data: {},  // 登録する入力内容
    }
  },
  created () {
    // 権限チェックを行う
    this.validateAuthority()

    // propsのvalueの値をdataのregist_dataに変える
    // 契約番号
    this.regist_data.contract_no = this.value.contract_no
    // プラン
    this.initDataPlan()
    // NEO
    this.initDataNeo()

    // 無料お試し版からのデータ移行がある場合
    if (this.value.migration === true) {
      // 無料お試し版からのデータ移行作業日付
      this.regist_data.migration_date = this.value.migration_date || ''

      // 無料お試し版からのデータ移行作業時刻（から）
      this.regist_data.migration_time_from = this.value.migration_time_from || ''

      // 無料お試し版からのデータ移行作業時刻（まで）
      this.regist_data.migration_time_to = this.value.migration_time_to || ''
    }
    else {
      // 無料お試し版からのデータ移行が無い場合
      // ご利用開始希望日
      this.regist_data.preferred_date = this.value.preferred_date || ''
    }

    // お見積番号
    if (this.value.estimate) {
      this.regist_data.estimate = this.value.estimate
    }

    // 備考
    this.regist_data.remarks = this.value.remarks || ''

    // サービス利用約款チェック
    this.regist_data.provision = this.value.provision_check || ''
  },
  methods: {
    /**
     * 権限チェックを行う
     */
    validateAuthority() {
      // 権限チェックを行う
      S203NeoContractOrder.view()
        .catch((err) => {
          // httpステータスコードが403の場合（権限エラー）
          if (err.response.status === 403) {
            // アプリケーションエラー画面へ遷移する
            this.$router.push({
              name: 'SupportApplicationError',
              params: {
                // 画面に表示するエラーメッセージ
                error_msg: this.forbidden_message
              }
            })
          }
        })
        .finally(() => {
          // 読み込み完了
          this.isLoading = false
        })
    },
    // 表示するデータの初期化 プラン
    initDataPlan() {
      this.regist_data.plan = {}

      // プラン名（必須）
      this.regist_data.plan.type = this.value.plan_name || ''
      // プランユーザー数
      // プランを選択している場合
      if (['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
        this.regist_data.plan.user = this.value.plan_user || 0
      }
    },
    // 表示するデータの初期化 NEO
    initDataNeo() {
      // AppSUiteユーザー数
      if (this.value.app_suite_user) {
        this.regist_data.app_suite_user = this.value.app_suite_user
      }

      // ウェブ会議室数
      if (this.value.web_conferencing) {
        this.regist_data.web_conferencing = this.value.web_conferencing
      }

      // オプションサービス
      if (this.value.option_service === true) {
        let option = {}
        // RoomMgr
        if (this.value.option_room_mgr === true) {
          option.room_mgr = true
        }
        // 交通費・経費精算
        if (this.value.option_expense_settlement === true) {
          option.expense_settlement = true
        }
        // タイムカード＋CLOUZA
        if (this.value.clouza_check === true) {
          option.clouza = {
            user: this.value.clouza_input,
            clouza_company: this.value.clouza_company_code,
            paid_leave_option: this.value.paid_leave_option,
          }
        }
        // ディスク増設
        if (this.value.option_disk === true) {
          option.disk = {
            disk_size: this.value.option_disk_size
          }
        }
        // Sync for smartphone
        if (this.value.option_sync === true) {
          option.sync = {
            user: this.value.option_sync_input
          }
        }
        // desknet'sドライブ ディスク増設
        if (this.value.option_dn_drive === true) {
          option.dn_drive = {
            disk_size: this.value.option_dn_drive_disk_size
          }
        }

        this.regist_data.option = option
      }

      // セキュリティオプション
      if (this.value.security_option === true) {
        let option = {}
        // BASIC認証
        if (this.value.basic_auth === true) {
          option.basic = {
            basic_id: this.value.basic_auth_user,
            basic_password: this.value.basic_auth_password,
            basic_except_ip: this.value.basic_auth_ip,
          }
        }
        // 接続元IPアドレス制限
        if (this.value.ip_restrictions === true) {
          option.connect_permit_ip = this.value.ip_restrictions_ip
        }
        // セキュアブラウザ
        if (this.value.secure_browser === true) {
          let itemQuantity = this.value.secure_browser_device

          // 端末認証なしの場合
          if (this.value.secure_browser_terminal === '01') {
            // secure_browser_deviceにdesknet's NEO ユーザー数を格納する
            itemQuantity = this.value.plan_user
          }
          option.secure = {
            secure_browser_terminal: this.value.secure_browser_terminal,
            secure_browser_device: itemQuantity,
            secure_except_ip: this.value.secure_browser_ip,
          }
        }
        // クライアント認証
        if (this.value.client_auth === true) {
          option.client = {
            device: this.value.client_auth_input,
            cert_except_ip: this.value.client_auth_ip,
          }
        }

        this.regist_data.security = option
      }

      // メールサービス
      if (this.value.mail_service === true) {
        let option = {}
        // WebARENA
        if (this.value.web_arena === true) {
          option.arena = {
            wa_domain: this.value.web_arena_domain,
            account: this.value.web_arena_input,
          }
        }
        // CYBERMAILΣ
        if (this.value.cyber === true) {
          option.cyber = {
            account: this.value.cyber_input,
            mailbox: this.value.cyber_capacity,
            options: [],
            keep: this.value.cyber_keep_period,
          }

          // オプション
          this.value.cyber_option.forEach((element, key) => {
            if (element === true) {
              option.cyber.options.push(('00' + key).slice(-2))
            }
          });
        }

        this.regist_data.mail = option
      }

      // メールセキュリティサービス
      if (this.value.mail_security_service === true) {
        let option = {}

        // MAILGATES Σ
        if (this.value.mailgates === true) {
          option.mailgates = {
            mailgates_domain: this.value.mailgates_domain,
            account: this.value.mailgates_input,
            options: [],
          }

          // オプション
          this.value.mailgates_option.forEach((element, key) => {
            if (element === true) {
              option.mailgates.options.push(('00' + (key+1)).slice(-2))
            }
          });
        }

        this.regist_data.mail_security = option
      }

      // ご希望サブドメイン名
      this.regist_data.sub_domain = this.value.sub_domain || ''


      // 無料お試し版からのデータ移行
      if (this.value.migration === true) {
        this.regist_data.migration_url = this.value.migration_url
      }
    },
    // 送信処理
    send() {
      // エラーメッセージを初期化する
      this.error_msg_list = []

      // 次へボタンをロックする
      this.isLoading = true;

      // お申し込みの登録処理を実施する
      S203NeoContractOrder.add(this.regist_data)
      .then(() => {
        // 完了時、ローカルストレージからプランを削除
        localStorage.removeItem('plan_name')

        // トップページへ遷移する
        this.$router.push({name: 'TopPage'})
      })
      .catch((error) => {
        // 次へボタンをロックを解除する
        this.isLoading = false;

        // 共通のエラー処理
        this.apiError(error, '登録処理', 'ContractNeo')

        // エラー発生時はエラーメッセージを表示する
        if (error.response.data && error.response.data.message) {
          // httpステータスコードが403の場合（権限エラー）
          if (error.response.status === 403) {
            // 画面上部にエラーメッセージを表示する
            this.error_msg_list.push(this.forbidden_message);
          }
          // CakePHP Exception
          else {
            // 画面上部にエラーメッセージを表示する
            this.error_msg_list.push(error.response.data.message)
          }
        }
        else if (error.response.data && error.response.data.error_list) {
          // バリデーションエラー
          // 項目確認のみで入力が無いので個別に表示しない
          for (let messages of error.response.data.error_list) {
            // 画面にエラーメッセージ表示
            this.error_msg_list.push(messages.error_msg)
          }
        }
        else {
          // その他エラー
          this.error_msg_list.push(error)
        }

        // 画面一番上へスクロールをする
        this.pageTopScroll()
      })
    },
  }
}
</script>

<style scoped>
.next-icon {
  margin-top: 2px;
}
.image-size {
  width: 200px;
  height: 150px;
}
</style>
